import { P2TextDescription, P2TextLabel } from 'react-bootstrap-common-script';
import { useAppSelector } from '../../../redux/hook';
import { Helpers } from '../../../utils/helper';
import { useNavigate } from 'react-router-dom';
import React from 'react';

interface AcknowledgementSegmentProps {
  transactionTimestamp: string;
}
function AcknowledgementSegment({ transactionTimestamp }: AcknowledgementSegmentProps) {
  const startApplicationFormData = useAppSelector((state) => state.app.ApplicationStartSlice.formData);
  const loginUser = useAppSelector((state) => state.auth.AuthenticationSlice.loginUser);
  const selectedCpfFormSN = useAppSelector((state) => state.app.ApplicationStageESlice.stage_e_selected_form_sn);

  function innerListItem(label: string, content: string = '') {
    return (
      <div className='d-flex flex-column flex-md-row polymer-stage-e-icon-gap align-items-md-center'>
        <div style={{ flex: 1 }}>
          <P2TextLabel bold={700} label={label} fontSize={'1.125rem'} lineHeight={'1.5rem'} />
        </div>
        <div style={{ flex: 2 }}>
          <P2TextDescription description_margin={'0px'} color='#333' description={content} />
        </div>
      </div>
    );
  }

  const localDate = Helpers.formatDate(transactionTimestamp, 'short', false);
  const localTime = transactionTimestamp?.split('T')[1];

  return (
    <div>
      <div
        className='d-flex flex-column justify-content-evenly polymer-stage-e_white-card'
        style={{
          maxWidth: '780px',
          margin: 'auto',
        }}>
        <div className='d-flex flex-column' style={{ gap: '1.5rem' }}>
          <div className='d-flex polymer-stage-e-icon-gap align-items-center'>
            <P2TextLabel bold={700} label={'Acknowledgement'} fontSize={'1.25rem'} lineHeight={'1.5rem'} />
          </div>
          {innerListItem('Name', loginUser?.name)}
          {innerListItem('Flat Address', startApplicationFormData?.selected_hdb_property?.address)}
          {innerListItem('CPF Withdrawal Form S/N', selectedCpfFormSN?.join(' AND '))}
          {innerListItem('Transaction Date', localDate)}
          {innerListItem('Transaction Time', localTime)}
        </div>
      </div>
    </div>
  );
}

export default AcknowledgementSegment;
